'use client';
import AboutUsPic from 'assets/images/aboutUs/aboutUs.png';
import Image from 'next/image';
import Styles from './aboutUs.module.scss';
import { MobileHeaderComp } from 'components';
import logoLight from 'assets/images/logo-light.png';
import logoDark from 'assets/images/logo-dark.png';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { ThemeEnum } from 'types';

const AboutUsComp = () => {
    const { theme } = useContext(GlobalContext);

    return (
        <>
            <MobileHeaderComp title="درباره آقای شهر" />
            <div className={`${Styles['about-us']} flex-column items-center bp-md-flex-row`}>
                <Image
                    src={AboutUsPic}
                    alt="about us page picture"
                    className={`${Styles['picture']} m-auto w-100`}
                    objectFit="contain"
                />
                <div className="flex-1 flex-column g-3">
                    <div>
                        <h3 className="mb-2 t-500 t-h2 d-pre-md-none">درباره اپلیکیشن و سایت آقای شهر</h3>

                        <Image
                            src={theme === ThemeEnum.dark ? logoDark : logoLight}
                            alt="آقای شهر"
                            width={103}
                            height={44}
                            className="d-md-none mb-2"
                        />
                        <p className={`${Styles['paragraph']} t-h3`}>
                            اپلیکیشن و سایت «آقای شهر» یک پلتفرم جامع نیازمندی‌هاست که برای پاسخگویی به تمام نیازهای
                            روزمره شما طراحی شده است. با مراجعه به این اپلیکیشن یا سایت، می‌توانید به راحتی خدمات و
                            کالاهای مورد نظر خود را پیدا کنید.
                        </p>
                    </div>
                    <div>
                        <h3 className="mb-2 t-500 t-h2">در آقای شهر می‌توانید:</h3>
                        <p className={`${Styles['paragraph']} t-h3`}>
                            <p>پزشکان و کلینیک‌های زیبایی معتبر را جستجو کنید.</p>
                            <p>تعمیرگاه‌های خودرو یا متخصصان تعمیر وسایل خانه را پیدا کنید.</p>
                            <p>بهترین دوره‌های آموزشی زبان، موسیقی یا مهارت‌های دیگر را بیابید.</p>
                            <p>اجناس عمده برای فروشگاه خود را تهیه کنید.</p>
                            <p>و از هزاران خدمات و امکانات دیگر بهره‌مند شوید.</p>
                        </p>
                        <p className={`${Styles['paragraph']} t-h3`}>
                            با«آقای شهر»، دیگر نیازی نیست وقت خود را برای پیدا کردن نیازهای مختلف هدر دهید. ما همه چیز
                            را در یک مکان برای شما فراهم کرده‌ایم!
                        </p>
                    </div>
                    {/* <div>
                        <h3 className="mb-2 t-500 t-h2">شماره تماس</h3>
                        <p className={`${Styles['paragraph']} t-h3`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است
                            چاپگرها و متون بلکه روزنامه و مجله
                        </p>
                    </div> */}
                </div>
            </div>
        </>
    );
};

export default AboutUsComp;
